import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Country } from "../../models/country.model";

export namespace CountryActions {

  @logDispatcher
  export class GetCountries {
    static readonly type = '[Country] GetCountries';
    constructor() { }
  }

  @logDispatcher
  export class GetCountriesSuccess {
    static readonly type = '[Country] GetCountriesSuccess';
    constructor(public countries: Country[]) { }
  }

  @logDispatcher
  export class GetCountriesFail {
    static readonly type = '[Country] GetCountriesFail';
    constructor(public error: any) { }
  }
}
